import { AxiosInterceptor } from "api/core/consts";

export const performanceApi = {
  searchPerformance: (paging, body) => AxiosInterceptor.post('performance/element/search' + paging, body),
};
